import React from 'react'
import CardShimmer from "./CardShimmer";

const ResultLoading = () => {
  return (
    <div className="mx-16 my-5">
    <h1 className="text-lg md:text-3xl py-4 text-white opacity-70">
      Loading
    </h1>
    <div className="flex flex-wrap gap-2  ">
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
      <CardShimmer />
    </div>
  </div>
  )
}

export default ResultLoading